const VaFileUploadKey = Symbol("VaFileUpload");
export {
  VaFileUploadKey as V
};
//# sourceMappingURL=types-8c5c5611.mjs.map
